import React from "react";
import { CustomButton } from "../dashboard/components";

interface KycPendingViaRainProps {
  icon: React.ReactNode;
  text: string;
  buttonText: string;
  onButtonClick?: () => void;
}

export default function KycModalWrapper({
  icon,
  text,
  buttonText,
  onButtonClick,
}: KycPendingViaRainProps) {
  return (
    <div className="flex flex-col">
      <div className="rounded-[4px] bg-black flex flex-col items-center justify-center">
        {icon}
      </div>
      <div className="rounded-b-md flex flex-col gap-1 overflow-clip">
        <div className="bg-[#18181C] p-[12px]">
          <p className="text-[#E6E8ED] text-center font-['Neue Montreal'] text-[16px] font-medium leading-[120%]">
            {text}
          </p>
        </div>
        <div className="bg-[#18181C] p-[12px]">
          <CustomButton className="w-full" onClick={onButtonClick}>
            {buttonText}
          </CustomButton>
        </div>
      </div>
    </div>
  );
}
